const THREE = require("three");
var Gamepad = require("./gamepad.js");
module.exports = function (RENDER, q, UI, UTILS, F, G, H) {
  function J(ai, aj) {
    return {
      identifier: ai.identifier,
      pageX: ai.pageX,
      pageY: ai.pageY,
      screenX: ai.screenX,
      screenY: ai.screenY,
      cb: aj,
    };
  }
  function K(ai) {
    for (var aj = 0; aj < ad.length; aj++) {
      if (ad[aj].identifier == ai) {
        return aj;
      }
    }
    return -1;
  }
  function N(keyCode, aj) {
    controls.idleTimer = 0;
    if (controls.keys) {
      if (
        aj &&
        controls.keys[keyCode] !== aj &&
        controls.inputChanger != null
      ) {
        if (controls.binds.moveKeys.val[controls.inputChanger]) {
          controls.binds.moveKeys.val[controls.inputChanger] = keyCode;
        } else if (controls.binds.streakKeys.val[controls.inputChanger - 18]) {
          controls.binds.streakKeys.val[controls.inputChanger - 18] = keyCode;
        } else if (controls.binds.toggleKeys.val[controls.inputChanger - 27]) {
          controls.binds.toggleKeys.val[controls.inputChanger - 27] = keyCode;
        } else if (controls.binds.premiumKeys.val[controls.inputChanger - 34]) {
          controls.binds.premiumKeys.val[controls.inputChanger - 34] = keyCode;
        } else {
          controls.binds[controls.inputChanger].val = keyCode;
        }
        controls.checkForScroll();
        saveVal("cont_" + controls.inputChanger, keyCode);
        showWindow(7, true);
        controls.inputChanger = null;
      } else {
        if (
          controls.keys[keyCode] !== aj &&
          keyCode == controls.binds.voiceKey.val
        ) {
          toggleRecord(aj);
        }
        if (!controls.enabled && keyCode != 27) {
          return;
        }
        if (controls.keys[keyCode] !== aj) {
          if (aj == 1 && !controls.didPressed[keyCode]) {
            controls.didPressed[keyCode] = 1;
          }
          controls.keys[keyCode] = aj;
          if (controls.binds.moveKeys.val.indexOf(keyCode) >= 0) {
            controls.updateMoveDir();
          }
          if (aj) {
            if (keyCode == controls.binds.swapKey.val) {
              controls.switchAction = 1;
            } else if (keyCode == controls.binds.meleeKey.val) {
              controls.switchAction = 2;
            } else if (keyCode == controls.binds.primKey.val) {
              controls.switchAction = 3;
            } else if (keyCode == controls.binds.equipKey.val) {
              controls.switchAction = 4;
            }
            window.pressButton(keyCode);
          } else {
            window.releaseButton(keyCode);
          }
        }
      }
    }
  }
  function keydown(e, aj) {
    if (
      (keyCode = aj || (e && (e.which || e.keyCode))) ==
      controls.binds.chatKey.val
    ) {
      window.pressButton(keyCode);
    } else if (
      document.activeElement != chatInput &&
      document.activeElement != tradeChatInput &&
      document.activeElement != terminalInput
    ) {
      if (controls.enabled && e && e.preventDefault) {
        e.preventDefault();
      }
      N(keyCode || 0, 1);
    }
  }
  function keyup(e, aj) {
    keyCode = aj || (e && (e.which || e.keyCode));
    if (controls.enabled && e && e.preventDefault) {
      e.preventDefault();
    }
    N(keyCode || 0, 0);
  }
  var controls = this;
  this.camRot = true;
  this.freeMouse = false;
  this.UsePointerLock = true;
  this.camOffset = false;
  this.spect = {
    target: null,
    speed: 1,
    followDis: G.specMinD,
    minD: G.specMinD,
    maxD: G.specMaxD,
  };
  this.camType = {
    isNormal: true,
    isTop: false,
    isSideX: false,
    isSideZ: false,
  };
  this.checkMobile = function () {
    let ai = RENDER.renderer.domElement;
    let aj =
      ai.requestPointerLock ||
      ai.mozRequestPointerLock ||
      ai.webkitRequestPointerLock;
    if (
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i) ||
      !aj
    ) {
      return true;
    }
  };
  this.isMobile = UI.isMobile = this.checkMobile();
  if (this.isMobile) {
    var W = false;
    var X = nipplejs.create({
      zone: document.getElementById("mobileJoystick"),
      size: 120,
      mode: "static",
      color: "black",
    });
    X.on("start", function () {
      if (!W) {
        window.dispatchEvent(new Event("resize"));
        W = true;
      }
    });
    X.on("move", function (aj, ak) {
      var al = ak.direction;
      var am = ak.distance || 50;
      var an = Math.abs(ak.angle.degree - 180);
      if (al) {
        if (controls.mblInput.gradSpeed) {
          controls.speedLmt = am / 50;
        }
        if ((an >= 165 && an <= 195) || (an >= 0 && an <= 15)) {
          keyup(null, controls.binds.moveKeys.val[0]);
          keyup(null, controls.binds.moveKeys.val[1]);
        } else {
          if (al.y == "up") {
            keyup(null, controls.binds.moveKeys.val[1]);
            keydown(null, controls.binds.moveKeys.val[0]);
          } else {
            keyup(null, controls.binds.moveKeys.val[0]);
          }
          if (al.y == "down") {
            keyup(null, controls.binds.moveKeys.val[0]);
            keydown(null, controls.binds.moveKeys.val[1]);
          } else {
            keyup(null, controls.binds.moveKeys.val[1]);
          }
        }
        if (an >= 75 && an <= 105) {
          keyup(null, controls.binds.moveKeys.val[2]);
          keyup(null, controls.binds.moveKeys.val[3]);
        } else {
          if (al.x == "left") {
            keyup(null, controls.binds.moveKeys.val[3]);
            keydown(null, controls.binds.moveKeys.val[2]);
          } else {
            keyup(null, controls.binds.moveKeys.val[2]);
          }
          if (al.x == "right") {
            keyup(null, controls.binds.moveKeys.val[2]);
            keydown(null, controls.binds.moveKeys.val[3]);
          } else {
            keyup(null, controls.binds.moveKeys.val[3]);
          }
        }
      }
    });
    X.on("end", function () {
      keyup(null, controls.binds.moveKeys.val[0]);
      keyup(null, controls.binds.moveKeys.val[1]);
      keyup(null, controls.binds.moveKeys.val[2]);
      keyup(null, controls.binds.moveKeys.val[3]);
    });
    let ai = window.mobileControlPositions
      ? window.mobileControlPositions
      : G.mobileControlPositions;
    Object.keys(ai).forEach(function (aj) {
      let ak = ai[aj];
      let al = document.getElementById(aj);
      if (ak.scale) {
        al.style.transform = "scale(" + ak.scale + ")";
      }
      ["left", "top", "right"].forEach(function (am) {
        if (ak[am] || ak[am] == 0) {
          al.style[am] = ak[am] * 100 + "%";
        }
      });
      if (ak.left == ak.right) {
        al.style.margin = "auto";
      }
    });
  }
  this.locklessChange = function (aj) {
    controls.enabled = aj;
    if (H.connected || F.singlePlayer) {
      if (controls.enabled) {
        enterGame();
      }
      UI.toggleControlUI(controls.enabled);
    }
  };
  this.gamepad = new Gamepad();
  var domElement = RENDER.renderer.domElement;
  this.hasPointerlock =
    "pointerLockElement" in document ||
    "mozPointerLockElement" in document ||
    "webkitPointerLockElement" in document;
  if (this.hasPointerlock) {
    domElement.requestPointerLock =
      domElement.requestPointerLock ||
      domElement.mozRequestPointerLock ||
      domElement.webkitRequestPointerLock;
    function Z() {
      controls.enabled =
        document.pointerLockElement === domElement ||
        document.mozPointerLockElement === domElement ||
        document.webkitPointerLockElement === domElement;
      if (H.connected || F.singlePlayer) {
        if (controls.enabled) {
          enterGame();
        }
        UI.toggleControlUI(controls.enabled);
        if (!controls.enabled) {
          controls.resetKeys();
        }
      }
    }
    document.addEventListener("pointerlockchange", Z, false);
    document.addEventListener("mozpointerlockchange", Z, false);
    document.addEventListener("webkitpointerlockchange", Z, false);
  }
  this.isn = 0;
  this.tmpInpts = [];
  this.getISN = function () {
    return this.isn++;
  };
  this.cntrlInput = {
    sensX: 1,
    sensY: 1,
    sensZ: 1,
    aimX: 1,
    aimY: 1,
    aimZ: 1,
    deadZoneR: 0.25,
    deadZoneL: 0.25,
    invert: false,
    vibration: true,
    triggerThres: 0.1,
    gradSpeed: false,
  };
  this.mblInput = {
    sensX: 1,
    sensY: 1,
    sensZ: 1,
    aimX: 1,
    aimY: 1,
    aimZ: 1,
    invert: false,
    vibration: true,
    gradSpeed: false,
  };
  this.kbmInput = {
    aimX: 1,
    aimY: 1,
    aimZ: 1,
    sensX: 1,
    sensY: 1,
    sensZ: 1,
    invert: false,
  };
  // Mouse flick / skip clamp (backported from newer game).
  // When `mouseSkipFix` is on, any single mousemove delta whose abs() is
  // >= `flickClamp` is treated as a flick and the previous good delta is
  // replayed instead. Wired up by the `mouseFlick` / `flickClamp` settings.
  this.mouseSkipFix = false;
  this.flickClamp = 500;
  this.masterLock = true;
  this.locked = false;
  this.enabled = false;
  this.idleTimer = 0;
  RENDER.camera.rotation.set(0, 0, 0);
  this.mouseX = 0;
  this.mouseY = 0;
  this.pitchObj = new q.Object3D();
  this.pitchObj.add(RENDER.camera);
  this.object = new q.Object3D();
  this.object.add(this.pitchObj);
  this.inputType = null;
  var a0;
  var a1;
  var a2;
  var a3;
  var a4;
  var a5;
  var a6;
  var a7 = Math.PI / 2;
  // Last in-clamp mousemove deltas, used by the flick-skip fix below.
  var aFlickDX = 0;
  var aFlickDY = 0;
  this.updateMouseInp = function () {
    if (controls.inputType != "cntrlInput" && controls.gamepad.active) {
      controls.gamepad.active = false;
    }
    a6 = controls[controls.inputType || "kbmInput"];
    a0 = controls.isAiming ? a6.aimX : a6.sensX;
    a1 =
      G.mouseSens *
      a0 *
      (controls.target ? G.camChaseSen : 1) *
      (RENDER.camera.fov / RENDER.fov);
    a2 = controls.isAiming ? a6.aimY : a6.sensY;
    a3 =
      G.mouseSens *
      a2 *
      (controls.target ? G.camChaseSen : 1) *
      (RENDER.camera.fov / RENDER.fov);
    if (window.spectating || controls.camRot) {
      controls.pitchObj.rotation.x -= a5 * a3 * (a6.invert ? -1 : 1);
      if (!controls.unlockView) {
        controls.pitchObj.rotation.x = Math.max(
          -a7,
          Math.min(a7, controls.pitchObj.rotation.x),
        );
      }
      controls.object.rotation.y -= a4 * a1;
      controls.yDr = controls.pitchObj.rotation.x % Math.PI2;
      controls.xDr = controls.object.rotation.y % Math.PI2;
    }
    a4 = a5 = 0;
  };
  function move(aj, ak) {
    if (!!controls.enabled && !window.locked && !window.noMouseInp) {
      if (aj.stopPropagation) {
        aj.stopPropagation();
      }
      if (aj.preventDefault) {
        aj.preventDefault();
      }
      controls.inputType = ak;
      controls.idleTimer = 0;
      var aDX = aj.movementX || aj.mozMovementX || aj.webkitMovementX || 0;
      var aDY = aj.movementY || aj.mozMovementY || aj.webkitMovementY || 0;
      if (!controls.mouseSkipFix || (aDX < controls.flickClamp && aDX > -controls.flickClamp)) {
        aFlickDX = aDX;
      }
      a4 += aFlickDX || 0;
      if (!controls.mouseSkipFix || (aDY < controls.flickClamp && aDY > -controls.flickClamp)) {
        aFlickDY = aDY;
      }
      a5 += aFlickDY || 0;
      controls.mouseX = aj.clientX;
      controls.mouseY = aj.clientY;
      RENDER.tmpMouse.set(a4, a5);
    }
  }
  domElement.addEventListener("drag", move, false);
  domElement.ondragover = function (aj) {
    aj.preventDefault();
  };
  domElement.addEventListener("mousemove", move, false);
  let tpRaycaster = new THREE.Raycaster();
  tpRaycaster.far = 6000;
  function mousedown(event, ak) {
    if (ak && controls.gamepad.active) {
      controls.gamepad.active = false;
    }
    if (!controls.masterLock) {
      if (!controls.enabled) {
        return controls.toggle(true);
      }
      if (document.activeElement == chatInput) {
        chatInput.blur();
      }
      if (document.activeElement == tradeChatInput) {
        tradeChatInput.blur();
      }
      if (event.stopPropagation) {
        event.stopPropagation();
      }
      switch (event.which) {
        case 3:
          controls.isAiming = 1;
          if (window.spectating) {
            window.spectMode(1);
          }
          break;
        default:
          if (event.which > 3 || event.which == 2) {
            if (event.preventDefault) {
              event.preventDefault();
            }
            keydown(null, 10000 + event.which);
          } else {
            controls.isShooting = 1;
            if (window.spectating) {
              window.spectMode(-1);
            }
          }
      }
    }
  }
  domElement.addEventListener("mousedown", mousedown, false);
  menuWindow.addEventListener(
    "mousedown",
    function (aj) {
      if (!controls.enabled) {
        if (aj.which > 3 || aj.which == 2) {
          if (aj.preventDefault) {
            aj.preventDefault();
          }
          keydown(null, 10000 + aj.which);
        }
      }
    },
    false,
  );
  function aa(aj, ak) {
    if (ak != "cntrlInput" && controls.gamepad.active) {
      controls.gamepad.active = false;
    }
    if (!controls.locked) {
      switch (aj.which) {
        case 3:
          controls.isAiming = 0;
          break;
        default:
          if (aj.which > 3 || aj.which == 2) {
            if (aj.preventDefault) {
              aj.preventDefault();
            }
            keyup(null, 10000 + aj.which);
          } else {
            controls.isShooting = 0;
          }
      }
    }
  }
  domElement.addEventListener("mouseup", aa, false);
  menuWindow.addEventListener(
    "mouseup",
    function (aj) {
      if (!controls.enabled) {
        if (aj.which > 3 || aj.which == 2) {
          if (aj.preventDefault) {
            aj.preventDefault();
          }
          keyup(null, 10000 + aj.which);
        }
      }
    },
    false,
  );
  function ab(aj) {
    aj = window.event || aj;
    var ak = -Math.max(-1, Math.min(1, aj.wheelDelta || -aj.detail));
    var al = ak > 0 ? -1 : 1;
    if (window.spectating) {
      if (controls.spect.target) {
        controls.spect.followDis -= al * 3;
        if (controls.spect.followDis < controls.spect.minD) {
          controls.spect.followDis = controls.spect.minD;
        }
        if (controls.spect.followDis > controls.spect.maxD) {
          controls.spect.followDis = controls.spect.maxD;
        }
      } else {
        controls.spect.speed += al;
        if (controls.spect.speed < 1) {
          controls.spect.speed = 1;
        }
        if (controls.spect.speed > 10) {
          controls.spect.speed = 10;
        }
      }
    }
    if (controls.skipScroll) {
      controls.skipScroll = false;
    } else {
      controls.scrollDelta = ak;
    }
    keydown(null, 20000);
    return false;
  }
  function ac() {
    if (controls.inputChanger != null) {
      keydown(null, 20000);
      keyup(null, 20000);
    }
    return false;
  }
  if (domElement.addEventListener) {
    domElement.addEventListener("mousewheel", ab, false);
    domElement.addEventListener("DOMMouseScroll", ab, false);
  } else {
    myitem.attachEvent("onmousewheel", ab);
  }
  menuWindow.addEventListener("mousewheel", ac, false);
  menuWindow.addEventListener("DOMMouseScroll", ac, false);
  var ad = [];
  var ae = {
    mobileUI: {
      move: function (aj, ak) {
        var al = aj.screenX - ad[ak].screenX;
        var am = aj.screenY - ad[ak].screenY;
        controls.fakeMouse(2, al, am, 0, "mblInput");
      },
    },
    mobileJump: {
      down: function () {
        mobileJump.style.transform = "scale(1.1)";
        keydown(null, controls.binds.jumpKey.val);
      },
      up: function () {
        mobileJump.style.transform = "";
        keyup(null, controls.binds.jumpKey.val);
      },
    },
    mobileCrouch: {
      down: function () {
        mobileCrouch.style.transform = "scale(1.1)";
        keydown(null, controls.binds.crouchKey.val);
      },
      up: function () {
        mobileCrouch.style.transform = "";
        keyup(null, controls.binds.crouchKey.val);
      },
    },
    mobileEsc: {
      down: function () {
        controls.toggle(false);
        setTimeout(function () {
          controls.resetKeys();
        });
      },
    },
    mobileAimShoot: {
      down: function () {
        mobileAimShoot.style.transform = "scale(1.1)";
        let aj = F.players.list.filter((ak) => ak.isYTMP)[0].weapon;
        if (controls.keys[controls.binds.aimKey.val]) {
          this.alreadyAim = true;
          controls.isShooting = 1;
        } else if (aj.melee) {
          controls.isShooting = 1;
        } else {
          N(controls.binds.aimKey.val, 1);
          if (aj.scope) {
            this.shootOnUp = true;
          } else {
            this.readyToShoot = true;
            setTimeout(() => {
              if (this.readyToShoot) {
                controls.isShooting = 1;
                if (aj.nAuto) {
                  setTimeout(() => (controls.isShooting = 0), 100);
                  this.autoFire = setInterval(() => {
                    controls.isShooting = 1;
                    setTimeout(() => (controls.isShooting = 0), 100);
                  }, aj.rate);
                }
              }
            }, aj.aimSpd + 50);
          }
        }
        if (window.spectating) {
          window.spectMode(-1);
        }
      },
      up: function () {
        this.readyToShoot = false;
        if (this.autoFire) {
          clearInterval(this.autoFire);
        }
        mobileAimShoot.style.transform = "";
        if (this.alreadyAim) {
          this.alreadyAim = false;
          controls.isShooting = 0;
        } else {
          if (this.shootOnUp) {
            this.shootOnUp = false;
            controls.isShooting = 1;
            setTimeout(() => (controls.isShooting = 0), 100);
          } else {
            controls.isShooting = 0;
          }
          N(controls.binds.aimKey.val, 0);
        }
      },
      move: function (aj, ak) {
        var al = aj.screenX - ad[ak].screenX;
        var am = aj.screenY - ad[ak].screenY;
        controls.fakeMouse(2, al, am, 0, "mblInput");
      },
    },
    mobileShoot: {
      down: function () {
        mobileShoot.style.transform = "rotate(90deg) scale(1.1)";
        controls.isShooting = 1;
        if (window.spectating) {
          window.spectMode(-1);
        }
      },
      up: function () {
        mobileShoot.style.transform = "";
        controls.isShooting = 0;
      },
    },
    mobileScope: {
      down: function () {
        mobileScope.style.transform = "scale(1.1)";
        N(controls.binds.aimKey.val, !controls.keys[controls.binds.aimKey.val]);
      },
      up: function () {
        mobileScope.style.transform = "";
      },
      move: function (aj, ak) {
        var al = aj.screenX - ad[ak].screenX;
        var am = aj.screenY - ad[ak].screenY;
        controls.fakeMouse(2, al, am, 0, "mblInput");
      },
    },
    mobileReload: {
      down: function () {
        mobileReload.style.transform = "scale(1.1)";
        keydown(null, controls.binds.reloadKey.val);
      },
      up: function () {
        mobileReload.style.transform = "";
        keyup(null, controls.binds.reloadKey.val);
      },
    },
    mobileSwap: {
      down: function () {
        mobileSwap.style.transform = "scale(1.1)";
        keydown(null, controls.binds.swapKey.val);
      },
      up: function () {
        mobileSwap.style.transform = "";
        keyup(null, controls.binds.swapKey.val);
      },
    },
  };
  if (this.isMobile) {
    mobileUI.addEventListener(
      "touchstart",
      function (aj) {
        if (!controls.masterLock) {
          if (!controls.enabled) {
            controls.toggle(true);
          }
          if (document.activeElement == chatInput) {
            chatInput.blur();
          }
          if (document.activeElement == tradeChatInput) {
            tradeChatInput.blur();
          }
          aj.preventDefault();
          for (var ak = aj.changedTouches, al = 0; al < ak.length; al++) {
            if (ae[ak[al].target.id]) {
              if (ae[ak[al].target.id].down) {
                ae[ak[al].target.id].down();
              }
              ad.push(J(ak[al], ak[al].target.id));
            }
          }
        }
      },
      false,
    );
    mobileUI.addEventListener(
      "touchmove",
      function (aj) {
        if (!controls.masterLock) {
          if (!controls.enabled) {
            controls.toggle(true);
          }
          aj.preventDefault();
          var ak;
          for (var al = aj.changedTouches, am = 0; am < al.length; am++) {
            if ((ak = K(al[am].identifier)) >= 0) {
              if (ae[ad[ak].cb].move) {
                ae[ad[ak].cb].move(al[am], ak);
              }
              ad[ak].screenX = al[am].screenX;
              ad[ak].screenY = al[am].screenY;
            }
          }
        }
      },
      false,
    );
    mobileUI.addEventListener(
      "touchend",
      function (aj) {
        if (!controls.locked) {
          var ak;
          for (var al = aj.changedTouches, am = 0; am < al.length; am++) {
            if ((ak = K(al[am].identifier)) >= 0) {
              if (ae[ad[ak].cb].up) {
                ae[ad[ak].cb].up();
              }
              ad.splice(ak, 1);
            }
          }
        }
      },
      false,
    );
    mobileUI.addEventListener(
      "touchcancel",
      function (aj) {
        aj.preventDefault();
        var ak;
        for (var al = aj.changedTouches, am = 0; am < al.length; am++) {
          ak = K(al[am].identifier);
          if (ae[ad[ak].cb].up) {
            ae[ad[ak].cb].up();
          }
          ad.splice(ak, 1);
        }
      },
      false,
    );
  }
  this.followCam = function (aj) {
    ag.set(aj.x, aj.y + aj.height, aj.z);
    controls.object.position.lerp(ag, 0.9);
    RENDER.camera.position.set(0, 0, this.spect.followDis);
    RENDER.camera.updateProjectionMatrix();
    RENDER.updateFrustum();
  };
  this.setCamPosOff = function () {
    RENDER.camera.updateMatrixWorld();
    controls.object.position.setFromMatrixPosition(RENDER.camera.matrixWorld);
    RENDER.camera.position.set(0, 0, 0);
    RENDER.camera.rotation.set(0, 0, 0);
  };
  this.velX = 0;
  this.velY = 0;
  this.velZ = 0;
  var keyCode;
  var ag = new q.Vector3(0, 0, 0);
  this.updateFreeCam = function (aj) {
    ag.set(0, 0, 0);
    if (this.keys[this.binds.moveKeys.val[0]]) {
      ag.z -= 1;
    }
    if (this.keys[this.binds.moveKeys.val[1]]) {
      ag.z += 1;
    }
    if (this.keys[this.binds.moveKeys.val[2]]) {
      ag.x -= 1;
    }
    if (this.keys[this.binds.moveKeys.val[3]]) {
      ag.x += 1;
    }
    if (this.keys[81]) {
      ag.y -= 1;
    }
    if (this.keys[69]) {
      ag.y += 1;
    }
    ag.applyQuaternion(RENDER.camera.getWorldQuaternion());
    var ak =
      (this.keys[this.binds.crouchKey.val] ? 0.08 : 0.04) *
      this.spect.speed *
      aj;
    controls.object.position.add(ag.multiplyScalar(ak));
    RENDER.camera.position.set(0, 0, 0);
    RENDER.updateFrustum();
  };
  this.camLookAt = function (aj, ak, al) {
    var am = UTILS.getXDire(
      this.object.position.x,
      this.object.position.y,
      this.object.position.z,
      aj,
      ak,
      al,
    );
    var an = UTILS.direction2D(
      this.object.position.z,
      this.object.position.x,
      al,
      aj,
    );
    this.target = {
      xD: am,
      yD: an,
      x: aj + G.camChaseDst * Math.sin(an) * Math.cos(am),
      y: ak - G.camChaseDst * Math.sin(am),
      z: al + G.camChaseDst * Math.cos(an) * Math.cos(am),
    };
  };
  this.update = function (aj) {
    if (this.target) {
      var ak = UTILS.angleDistance(this.object.rotation.y, this.target.yD);
      this.object.rotation.y += ak * aj * G.camChaseTrn;
      ak = UTILS.angleDistance(controls.pitchObj.rotation.x, this.target.xD);
      this.pitchObj.rotation.x += ak * aj * G.camChaseTrn;
      ak =
        UTILS.getD3D(
          this.object.position.x,
          this.object.position.y,
          this.object.position.z,
          this.target.x,
          this.target.y,
          this.target.z,
        ) *
        aj *
        G.camChaseSpd;
      var al = UTILS.direction2D(
        this.object.position.z,
        this.object.position.x,
        this.target.z,
        this.target.x,
      );
      var am = UTILS.getXDire(
        this.object.position.x,
        this.object.position.y,
        this.object.position.z,
        this.target.x,
        this.target.y,
        this.target.z,
      );
      this.object.position.x -= ak * Math.sin(al) * Math.cos(am);
      this.object.position.y += ak * Math.sin(am);
      this.object.position.z -= ak * Math.cos(al) * Math.cos(am);
      RENDER.updateFrustum();
    }
  };
  this.rotateCam = function (aj, ak, al) {
    RENDER.camera.rotation.y = aj;
    RENDER.camera.rotation.x = ak;
    RENDER.camera.rotation.z = al;
  };
  this.moveCam = function (aj, ak, al) {
    controls.object.position.set(aj, ak, al);
    RENDER.updateFrustum();
  };
  this.keyInfo = [
    null,
    null,
    null,
    null,
    "jumpKey",
    "crouchKey",
    "meleeKey",
    "swapKey",
    "reloadKey",
    "sprayKey",
    "aimKey",
    "chatKey",
    "voiceKey",
    "primKey",
    "inspKey",
    "pListKey",
    "interactKey",
    "dropKey",
    null,
    null,
    null,
    null,
    null,
    "interactSecKey",
    "wepVisKey",
    "shootKey",
    "sBoardKey",
    null,
    null,
    null,
    null,
    null,
    null,
    "equipKey",
    null,
    null,
    null,
    null,
  ];
  this.binds = {
    primKey: {
      def: 84,
      val: parseInt(getSavedVal("cont_primKey") || 84),
    },
    reloadKey: {
      def: 82,
      val: parseInt(getSavedVal("cont_reloadKey") || 82),
    },
    jumpKey: {
      def: 32,
      val: parseInt(getSavedVal("cont_jumpKey") || 32),
    },
    pListKey: {
      def: 18,
      val: parseInt(getSavedVal("cont_pListKey") || 18),
    },
    sBoardKey: {
      def: 9,
      val: parseInt(getSavedVal("cont_sBoardKey") || 9),
    },
    interactKey: {
      def: 71,
      val: parseInt(getSavedVal("cont_interactKey") || 71),
    },
    interactSecKey: {
      def: 72,
      val: parseInt(getSavedVal("cont_interactSecKey") || 72),
    },
    sprayKey: {
      def: 70,
      val: parseInt(getSavedVal("cont_sprayKey") || 70),
    },
    inspKey: {
      def: 88,
      val: parseInt(getSavedVal("cont_inspKey") || 88),
    },
    swapKey: {
      def: 69,
      val: parseInt(getSavedVal("cont_swapKey") || 69),
    },
    shootKey: {
      def: 220,
      val: parseInt(getSavedVal("cont_shootKey") || 220),
    },
    aimKey: {
      def: 221,
      val: parseInt(getSavedVal("cont_aimKey") || 221),
    },
    crouchKey: {
      def: 16,
      val: parseInt(getSavedVal("cont_crouchKey") || 16),
    },
    meleeKey: {
      def: 81,
      val: parseInt(getSavedVal("cont_meleeKey") || 81),
    },
    equipKey: {
      def: 67,
      val: parseInt(getSavedVal("cont_equipKey") || 67),
    },
    chatKey: {
      def: 13,
      val: parseInt(getSavedVal("cont_chatKey") || 13),
    },
    voiceKey: {
      def: 86,
      val: parseInt(getSavedVal("cont_voiceKey") || 86),
    },
    dropKey: {
      def: 90,
      val: parseInt(getSavedVal("cont_dropKey") || 90),
    },
    wepVisKey: {
      def: -1,
      val: parseInt(getSavedVal("cont_wepVisKey") || -1),
    },
    streakKeys: {
      def: [49, 50, 51, 52, 53],
      val: [
        parseInt(getSavedVal("cont_18") || 49),
        parseInt(getSavedVal("cont_19") || 50),
        parseInt(getSavedVal("cont_20") || 51),
        parseInt(getSavedVal("cont_21") || 52),
        parseInt(getSavedVal("cont_22") || 53),
      ],
    },
    moveKeys: {
      def: [87, 83, 65, 68],
      val: [
        parseInt(getSavedVal("cont_0") || 87),
        parseInt(getSavedVal("cont_1") || 83),
        parseInt(getSavedVal("cont_2") || 65),
        parseInt(getSavedVal("cont_3") || 68),
      ],
    },
    toggleKeys: {
      def: [-1, -1, -1, -1, -1, -1],
      val: [
        parseInt(getSavedVal("cont_27") || -1),
        parseInt(getSavedVal("cont_28") || -1),
        parseInt(getSavedVal("cont_29") || -1),
        parseInt(getSavedVal("cont_30") || -1),
        parseInt(getSavedVal("cont_31") || -1),
        parseInt(getSavedVal("cont_32") || -1),
      ],
    },
    premiumKeys: {
      def: [-1, -1, -1, -1],
      val: [
        parseInt(getSavedVal("cont_34") || -1),
        parseInt(getSavedVal("cont_35") || -1),
        parseInt(getSavedVal("cont_36") || -1),
        parseInt(getSavedVal("cont_37") || -1),
      ],
    },
  };
  this.setupBinds = function () {
    controls.scrollToSwap = true;
    controls.toggleSets = [
      getSavedVal("cont_27_set") || -1,
      getSavedVal("cont_28_set") || -1,
      getSavedVal("cont_29_set") || -1,
      getSavedVal("cont_30_set") || -1,
      getSavedVal("cont_31_set") || -1,
      getSavedVal("cont_32_set") || -1,
    ];
  };
  this.setupBinds();
  this.resetBinds = function () {
    for (var aj in controls.binds) {
      controls.binds[aj].val = controls.binds[aj].def;
    }
  };
  this.moveDirs = [
    [0, -1],
    [0, 1],
    [-1, 0],
    [1, 0],
  ];
  this.checkForScroll = function () {
    for (
      var aj = [
          "jumpKey",
          "crouchKey",
          "meleeKey",
          "swapKey",
          "primKey",
          "reloadKey",
          "sprayKey",
          "inspKey",
          "aimKey",
          "shootKey",
          "chatKey",
          "voiceKey",
          "pListKey",
          "interactKey",
          "interactSecKey",
          "dropKey",
          "wepVisKey",
          "sBoardKey",
          "equipKey",
        ],
        ak = 0;
      ak < aj.length;
      ak++
    ) {
      if (controls.binds[aj[ak]].val == 20000) {
        controls.scrollToSwap = false;
        return;
      }
    }
    if (
      controls.binds.streakKeys.val.indexOf(20000) >= 0 ||
      controls.binds.moveKeys.val.indexOf(20000) >= 0 ||
      controls.binds.toggleKeys.val.indexOf(20000) >= 0 ||
      controls.binds.premiumKeys.val.indexOf(20000) >= 0
    ) {
      controls.scrollToSwap = false;
      return;
    } else {
      controls.scrollToSwap = true;
      return;
    }
  };
  this.checkForScroll();
  this.export = function () {
    var aj = {};
    for (
      var ak = [
          "jumpKey",
          "crouchKey",
          "meleeKey",
          "swapKey",
          "primKey",
          "reloadKey",
          "sprayKey",
          "inspKey",
          "aimKey",
          "shootKey",
          "chatKey",
          "voiceKey",
          "pListKey",
          "interactKey",
          "interactSecKey",
          "dropKey",
          "wepVisKey",
          "sBoardKey",
          "streakKeys",
          "moveKeys",
          "toggleKeys",
          "equipKey",
          "premiumKeys",
        ],
        al = 0;
      al < ak.length;
      al++
    ) {
      if (typeof controls.binds[ak[al]].val == "object") {
        aj[ak[al]] = [];
        for (var am = 0; am < controls.binds[ak[al]].val.length; am++) {
          if (
            controls.binds[ak[al]].val[am] != controls.binds[ak[al]].def[am]
          ) {
            aj[ak[al]][am] = controls.binds[ak[al]].val[am];
          }
        }
        if (!aj[ak[al]].length) {
          delete aj[ak[al]];
        }
      } else if (controls.binds[ak[al]].val != controls.binds[ak[al]].def) {
        aj[ak[al]] = controls.binds[ak[al]].val;
      }
    }
    return aj;
  };
  this.updateMoveDir = function () {
    var aj = 0;
    var ak = 0;
    for (var al = 0; al < controls.binds.moveKeys.val.length; ++al) {
      if (controls.keys[controls.binds.moveKeys.val[al]]) {
        aj += controls.moveDirs[al][0];
        ak += controls.moveDirs[al][1];
      }
    }
    this.moveDir = aj == 0 && ak == 0 ? null : Math.atan2(ak, aj);
  };
  window.addEventListener("keydown", keydown, false);
  window.addEventListener("keyup", keyup, false);
  this.mapping = {
    button_1: {
      KEY: "jumpKey",
    },
    button_2: {
      KEY: "crouchKey",
    },
    button_3: {
      KEY: "reloadKey",
    },
    shoulder_bottom_left: {
      KEY: "aimKey",
    },
    button_4: {
      KEY: "swapKey",
    },
    shoulder_top_left: {
      KEY: "swapKey",
    },
    shoulder_top_right: {
      KEY: "meleeKey",
    },
    shoulder_bottom_right: {
      THRES: true,
      MOUSE: true,
    },
    select: {
      KEY: "pListKey",
    },
    d_pad_up: {
      KEY: "voiceKey",
    },
    d_pad_down: {
      KEY: "sprayKey",
    },
    d_pad_left: {
      KEY: "interactKey",
    },
    d_pad_right: {
      KEY: "dropKey",
    },
  };
  this.gamepad.on(
    ["press", "hold", "release"],
    Object.keys(this.mapping),
    function (aj) {
      if (aj.type == "press") {
        if (
          controls.mapping[aj.button].MOUSE &&
          (aj.value >= controls.cntrlInput.triggerThres ||
            !controls.mapping[aj.button].THRES)
        ) {
          controls.fakeMouse(0);
        } else if (controls.mapping[aj.button].KEY) {
          keydown(null, controls.binds[controls.mapping[aj.button].KEY].val);
        }
      } else if (aj.type == "release") {
        if (controls.mapping[aj.button].MOUSE) {
          controls.fakeMouse(1);
        } else {
          keyup(null, controls.binds[controls.mapping[aj.button].KEY].val);
        }
      } else if (aj.type == "hold" && controls.mapping[aj.button].THRES) {
        if (aj.value >= controls.cntrlInput.triggerThres) {
          controls.fakeMouse(0);
        } else {
          controls.fakeMouse(1);
        }
      }
    },
  );
  this.gamepad.on("hold", "stick_axis_left", function (aj) {
    if (controls.cntrlInput.gradSpeed) {
      controls.speedLmt =
        Math.max(Math.abs(aj.value[0]), Math.abs(aj.value[1])) /
        (1 - controls.cntrlInput.deadZoneL);
    }
    if (aj.value[1] <= -controls.cntrlInput.deadZoneL) {
      keyup(null, controls.binds.moveKeys.val[1]);
      keydown(null, controls.binds.moveKeys.val[0]);
    } else {
      keyup(null, controls.binds.moveKeys.val[0]);
    }
    if (aj.value[1] >= controls.cntrlInput.deadZoneL) {
      keyup(null, controls.binds.moveKeys.val[0]);
      keydown(null, controls.binds.moveKeys.val[1]);
    } else {
      keyup(null, controls.binds.moveKeys.val[1]);
    }
    if (aj.value[0] <= -controls.cntrlInput.deadZoneL) {
      keyup(null, controls.binds.moveKeys.val[3]);
      keydown(null, controls.binds.moveKeys.val[2]);
    } else {
      keyup(null, controls.binds.moveKeys.val[2]);
    }
    if (aj.value[0] >= controls.cntrlInput.deadZoneL) {
      keyup(null, controls.binds.moveKeys.val[2]);
      keydown(null, controls.binds.moveKeys.val[3]);
    } else {
      keyup(null, controls.binds.moveKeys.val[3]);
    }
  });
  this.gamepad.on("release", "stick_axis_left", function () {
    keyup(null, controls.binds.moveKeys.val[0]);
    keyup(null, controls.binds.moveKeys.val[1]);
    keyup(null, controls.binds.moveKeys.val[2]);
    keyup(null, controls.binds.moveKeys.val[3]);
  });
  this.gamepad.on("hold", "stick_axis_right", function (aj) {
    controls.fakeMouse(
      2,
      controls.applyDeadzone(aj.value[0], controls.cntrlInput.deadZoneR),
      controls.applyDeadzone(aj.value[1], controls.cntrlInput.deadZoneR),
      0,
    );
  });
  this.gamepad.on("press", "start", function () {
    controls.toggle(!controls.enabled);
  });
  this.applyDeadzone = function (aj, ak) {
    let al = (Math.abs(aj) - ak) / (1 - ak);
    if (al < 0) {
      al = 0;
    }
    return al * (aj > 0 ? 1 : -1);
  };
  this.fakeKey = function (aj, ak = 0) {
    if (ak == 0) {
      keydown(null, aj);
    }
    if (ak == 1) {
      keyup(null, aj);
    }
  };
  var ah = {
    movementX: 0,
    movementY: 0,
    which: 0,
  };
  this.fakeMouse = function (aj = 0, ak = 0, al = 0, am = 0, an) {
    an = an || "cntrlInput";
    ah.movementX = ak;
    ah.movementY = al;
    ah.which = am;
    if (aj == 0) {
      mousedown(ah, an);
    }
    if (aj == 1) {
      aa(ah, an);
    }
    if (aj == 2) {
      move(ah, an);
    }
  };
  this.toggle = function (aj) {
    if (this.locked || this.masterLock) {
      if (UI.hasEndScreen && aj) {
        UI.toggleEndScreen();
      }
    } else if (windowHolder.style.display == "block") {
      if (aj) {
        UI.toggleWindow(false, this.gamepad.active);
      }
    } else if (controls.UsePointerLock) {
      if (aj) {
        domElement.requestPointerLock();
      } else {
        document.exitPointerLock();
      }
    } else {
      this.locklessChange(aj);
    }
  };
  this.disable = function () {
    controls.toggle(false);
    controls.locked = true;
  };
  this.reset = function () {
    this.isShooting = 0;
    this.isAiming = 0;
    this.keys = {};
    this.didPressed = {};
    this.speedLmt = 1;
    this.switchAction = 0;
    this.scrollDelta = 0;
    this.xDr = 0;
    this.yDr = 0;
    this.tmpInpts.length = 0;
    this.isn = 0;
    this.moveDir = null;
    this.skipScroll = false;
    this.scrollToSwap = this.scrollToSwap;
    this.inputChanger = null;
    this.target = null;
    this.locked = false;
    this.spect.target = null;
    controls.pitchObj.rotation.x = 0;
    controls.object.rotation.y = 0;
    RENDER.camera.rotation.set(0, 0, 0);
    RENDER.zoom(1);
  };
  this.resetKeys = function () {
    controls.isShooting = 0;
    controls.isAiming = 0;
    controls.keys = {};
    controls.updateMoveDir();
  };
};
